import { render, staticRenderFns } from "./SampleOrdersForDelivery.vue?vue&type=template&id=56d3aa1e&scoped=true"
import script from "./SampleOrdersForDelivery.vue?vue&type=script&lang=js"
export * from "./SampleOrdersForDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d3aa1e",
  null
  
)

export default component.exports